import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as IdeaBoxLogo } from '../../static/graphics/logos/ideabox-logo.svg'
import AnimatedArticleBanner from '../common/animated-article-banner'

export class HomeView extends React.Component {
    render() {
        return (
            <>
                <div className="container mb-4">
                    <h1 className="text-primary text-center mb-4">
                        Welcome to the Siemens Mobility Idea Box
                    </h1>

                    <div className="text-center mb-4">
                        <IdeaBoxLogo className="text-center" />
                    </div>

                    <h5 className="text-secondary text-center mt-2">
                        <Link to="/explore">Explore </Link> or{' '}
                        <Link to="/submit">submit </Link>
                        ideas here to let the company know the changes you’d
                        like to see!
                    </h5>

                    <span className="my-2">&nbsp;</span>

                    <h5 className="text-secondary text-center mt-4">
                        To get your voice heard...
                    </h5>

                    <div className="row mx-4 px-4 mt-4">
                        <div className="col-sm-12 col-md-4 col-lg-4 mb-2">
                            <Link to="/explore">
                                <h6 className="text-secondary  text-center">
                                    <FontAwesomeIcon
                                        icon="thumbs-up"
                                        className="mr-2"
                                    />
                                    Vote for existing ideas
                                </h6>
                            </Link>
                        </div>
                        <div className="col-sm-12 col-md-4 col-lg-4 mb-2">
                            <Link to="/explore">
                                <h6 className="text-secondary text-center">
                                    <FontAwesomeIcon
                                        icon="comment-alt"
                                        className="mr-2"
                                    />
                                    Discuss existing ideas
                                </h6>
                            </Link>
                        </div>
                        <div className="col-sm-12 col-md-4 col-lg-4 mb-2 ">
                            <Link to="/submit">
                                <h6 className="text-secondary text-center">
                                    <FontAwesomeIcon
                                        icon="paper-plane"
                                        className="mr-2"
                                    />
                                    Submit new ideas
                                </h6>
                            </Link>
                        </div>
                    </div>
                </div>

                <span className="my-2">&nbsp;</span>



                <AnimatedArticleBanner className="mt-2" />
            </>
        )
    }
}

export default HomeView
